export function getHeader(masterBusiness, branches, branchCount) {
  let result = [
    { name: `${branchCount} branches` },
    { name: masterBusiness?.name, id: masterBusiness?.id },
    ...branches.map((branch) => ({
      name: branch?.businessName,
      id: branch?.branchId,
    })),
  ];

  return result;
}

export function mapBranchData(data, branchProducts) {
  return data.map((product) => {
    const branchesData = branchProducts.map((branch) => {
      const branchProduct = branch.products.find(
        (p) => p.masterProductId === product.id
      );
      return branchProduct
        ? branchProduct.childProductDetils
        : { price: "-", discounted: "-", discount: "-" };
    });

    return {
      masterProductId: product.id,
      productName: product.productName,
      headquarters: product,
      branches: branchesData,
    };
  });
}

export function getProductsCount(products, branchProducts) {
  const array = [products.length];

  console.log("branchProducts", branchProducts);

  branchProducts.forEach((branch) => {
    let count = 0;
    branch?.products.forEach((product) => {
      if (product.childProductDetils?.childProductId) count++;
    });
    array.push(count);
  });

  return array;
}
